import { ShortTime } from "../utils/dom";
import Img from "./img";
import { useRef, RefObject, MouseEvent } from "react";
import { ChatMessage } from "../contexts/ChatMessageProvider";

interface ChatBubbleProps {
	msg: ChatMessage;
	meId: string;
	active: boolean;
	onClick: (e: MouseEvent<HTMLDivElement>) => void;
	onTriggerRef?: (ref: RefObject<HTMLDivElement | null>) => void;
}

const ChatBubble = ({ msg, meId, active, onClick, onTriggerRef }: ChatBubbleProps) => {
	const ellipsisRef = useRef<HTMLDivElement>(null);
	// Use String() to ensure consistent comparison (API may return string, profile.id may be number)
	const isMe = String(msg.userId) === String(meId);
	const meThem = isMe ? "my" : "their";

	const handleClick = (e: MouseEvent<HTMLDivElement>) => {
		if (isMe && onTriggerRef) {
			onTriggerRef(ellipsisRef);
		}
		onClick(e);
	};

	return (
		<div
			className={`bubble-spacer ${meThem}-bubble ${
				active ? "active" : ""
			}`}
			data-testid="chat-bubble"
			onClick={handleClick}
		>
			<div className={`text-bubble ${isMe ? 'same-color-3' : ''}`} data-testid="chat-bubble-text" data-who={meThem}>
				{msg.text}
				{isMe ? (
					<div className="chat-bubble-ellipsis" ref={ellipsisRef}>
						<Img className="dark-icon" src="/images/svg/vert-ellipsis.svg" />
						<Img className="light-icon" src="/images/svg/vert-ellipsis-dark.svg" />
					</div>
				) : (
					""
				)}
			</div>
			<div className="date">
				{ShortTime(msg.createdDate)}
			</div>
		</div>
	);
};

export default ChatBubble;
